export default __webpack_public_path__ + "static/media/check_ring.41de00f5.svg";